/** @jsx jsx */
import { any } from 'prop-types'
import { jsx, Flex } from 'theme-ui'
import './nav.css'
import React, { useState } from 'react'
import { func } from 'prop-types'
import ParseLink from '../common/ParseLink'
import { useBreakpoint } from '../../utils/useWindowWidth'

const NavList = ({ navList, closeMobileModal }) => {
  const breakpoint = useBreakpoint()
  const isDesktop = breakpoint === 'desktop'
  return (
    <React.Fragment>
      {navList.map(parentNav => {
        const [showSubMenu, setShowSubMenu] = useState(false)
        const hasChildren =
          parentNav.navLinks && parentNav.navLinks.length !== 0
        return (
          <div key={parentNav.id} className="popover__wrapper">
            <div
              className="popover__title"
              sx={{
                variant: 'links.navigation',
                pb: isDesktop ? 20 : showSubMenu ? 20 : 0,
              }}
            >
              <Flex
                onClick={() => setShowSubMenu(!showSubMenu)}
                sx={{ justifyContent: 'space-between' }}
              >
                <div>{parentNav.title}</div>
                <div sx={{ mr: 2 }}>
                  {hasChildren &&
                    !isDesktop &&
                    (!showSubMenu ? (
                      <i className="arrow down"></i>
                    ) : (
                      <i className="arrow up"></i>
                    ))}
                </div>
              </Flex>
              {!isDesktop && !showSubMenu && (
                <div className="bottomBorder"></div>
              )}
            </div>
            {hasChildren && (isDesktop ? true : showSubMenu) && (
              <div className="popover__content">
                <ul>
                  {parentNav.navLinks.map(({ id, title, slug }) => (
                    <li key={id}>
                      <ParseLink
                        isMenuLink
                        id={id}
                        text={title}
                        slug={slug}
                        closeMobileModal={closeMobileModal}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )
      })}
    </React.Fragment>
  )
}

NavList.propTypes = {
  navList: any.isRequired,
  closeMobileModal: func,
}

export default NavList
